var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "input-number",
        _vm.size ? "input-size-" + _vm.size : "",
        { "is-disabled": _vm.disabled }
      ]
    },
    [
      _c(
        "span",
        {
          staticClass: "btn left",
          class: { disabled: _vm.minDisabled },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.decrease($event)
            }
          }
        },
        [_c("i", { staticClass: "icon-jian iconfont" })]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "btn right",
          class: { disabled: _vm.maxDisabled },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.increase($event)
            }
          }
        },
        [_c("i", { staticClass: "icon-jia iconfont" })]
      ),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        staticClass: "inner-input",
        attrs: { type: "text", disabled: _vm.disabled },
        domProps: { value: _vm.displayValue },
        on: {
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.increase($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.decrease($event)
            }
          ],
          input: _vm.onInput,
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          change: _vm.onChange
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-004d06ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-004d06ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/inputNumber.vue
// module id = 14
// module chunks = 0